import { theme } from "../../theme";
export const eventSelector = {
    allEventsIcon: {
        background: theme.palette.primary.main,
        borderRadius: "50%",
        minWidth: "32px",
        height: "32px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#fff",
        fontSize: "16px",
        marginRight: "10px",
    },
    archivedEventsIcon: {
        background: theme.palette.grey["800"],
        borderRadius: "50%",
        minWidth: "32px",
        height: "32px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#fff",
        fontSize: "16px",
        marginRight: "10px",
    },
    eventButton: {
        textDecoration: "none",
        textAlign: "left",
    },
    eventTitle: {
        fontSize: "16px",
        fontWeight: 600,
        color: theme.palette.common.black,
    },
    eventStatus: {
        fontSize: "12px",
        color: theme.palette.common.black,
    },
    badgeIcon: {
        color: "#A8A8A8",
    },
    item: {
        fontWeight: 600,
        color: "#242424",
    },
    chevronIcon: {
        color: theme.palette.text.primary,
    },
    eventItem: {
        minWidth: "32px",
        height: "32px",
        marginRight: "10px",
    },
    eventItemAvatar: {
        width: "32px",
        height: "32px",
    },
    eventSelectorMenu: {
        '& .MuiAvatar-root': { height: '32px', width: '32px', '& > svg': { height: '1rem', width: '1rem' } },
        '& .MuiMenuItem-root': {
            fontWeight: 600,
            color: "#242424",
        }
    },
    selectorMenuItemAvatar:{minWidth:'32px', mr:'10px'},
    button:{textAlign:'left',alignItems:'center', p:0,lineHeight:'initial'},
    mainDiv:{'& > .MuiTypography-root':{
        lineHeight:'1.5',
      }}
} as const;